import { Col, Row } from "reactstrap";
import { Constants } from "../../../assets/utils/lib/constants";
import Drawer from "../../../assets/vfx/drawer/drawer";
import { CountyDto } from "../../../services/dto";
import DisplayData from "../../common/DisplayData/DisplayData";
import { DropdownOption } from "../../../assets/vfx/controls/components/dropdown/controlDropdown";
import { ConfirmationDialog } from "../../../assets/types";

interface CountyViewProps {
  data: CountyDto | undefined;
  stateLookup: DropdownOption[] | undefined;
  show: boolean;
  onHide: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

export const CountyView = (props: CountyViewProps) => {
  const state = props?.stateLookup?.find(
    (x: { value: any }) => x.value === props?.data?.stateId
  )?.display;

  return (
    <Drawer.View
      className="w-30"
      show={props?.show}
      backdrop={true}
      placement="end"
      scroll={true}
      onHide={props?.onHide}
      onEdit={props?.onEdit}
      title="View County"
      onDelete={props.onDelete}
      modalDialogProps={new ConfirmationDialog().get(props.onDelete, "Delete", {
        Name: props?.data?.name ?? Constants.emptyString,
      })}
    >
      <Row className="mb-3">
        <Col md={12}>
          <DisplayData
            text="Name"
            importedData={props?.data?.name ?? Constants.emptyString}
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={12}>
          <DisplayData
            text="Description"
            importedData={props?.data?.description ?? Constants.emptyString}
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={12}>
          <DisplayData text="State" importedData={state} />
        </Col>
      </Row>
    </Drawer.View>
  );
};
